export default __webpack_public_path__ + "static/media/TypewriterTipTip.c5b35bdb.png";